<!--
 Компонент таймера дискаунта
 @versions: baseline, landing v14, v15
 -->
<template>
  <div
    :class="['landing-timer']"
  >
    <div class="landing-timer__wrapper">
      <template v-if="!timeIsUp">
        <p class="paragraph_14-400">
          {{ label || $t('lp_v7_discount_value', [`${discount}`]) }}
        </p>
        <span class="landing-timer__time">{{ timer }}</span>
      </template>
      <template v-else>
        <CNuxtImg
          src="logo_white_bg.webp"
          alt="logo"
          class="landing-timer__logo"
          min-height="24px"
          localize
        />
      </template>
    </div>

    <base-button
      :class="['landing-timer__button', { 'landing-timer__button--small': locale !== 'en' }]"
      :type="landingTheme"
      @click="emits('clickGetPlan')"
    >
      {{ $t('lp_v7_get_plan_button1') }}
    </base-button>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  landingTheme: {
    type: String,
    default: 'blue',
  },
  discount: {
    type: Number,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  timer: String,
  timerCount: {
    type: Number,
    required: true,
  },
});

const emits = defineEmits(['clickGetPlan']);
const { locale } = useI18n();

const timeIsUp = computed(() => {
  return props.timerCount <= 0;
});
</script>

<style lang="scss" scoped>
.landing-timer {
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  margin: 0 auto;
  width: 100%;
  padding: 16px 16px 16px 32px;
  max-width: 600px;
  background: $white;
  z-index: 10;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.15);

  &__wrapper {
    flex: 1;
    background: $white;
    margin-right: 8px;
  }

  &__time {
    font-family: $primary-fonts;
    font-size: 18px;
    color: $red;
    font-weight: 800;
    line-height: 27px;
  }

  &__logo {
    width: 120px;

    @media (min-width: 600px ) {
      width: 150px;
    }
  }

  &__button {
    max-width: 143px;
    font-size: 16px;
    padding: 14px 16px 15px 16px;

    &--small {
      max-width: 158px;
      font-size: 15px;
    }
  }
}

.slide-up-enter-from, .slide-up-leave-to {
  transform: translateY(-100%);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all .5s ease;
}

.slide-up-enter-to, .slide-up-leave-from {
  transform: translateY(0);
}
</style>
